import * as React from "react";
import { Spinner, StyledButton } from "./styles";
import { ButtonTypeProps } from "./types";

export const Button = ({
  onClick,
  disabled,
  label,
  type,
  style,
  children,
  className,
  loading = false,
  loadingLabel = "Loading...",
}: ButtonTypeProps) => {
  return (
    <StyledButton
      className={className}
      type={type}
      onClick={onClick}
      disabled={disabled}
      style={style}
    >
      {loading ? (
        <>
          <Spinner />
          {loadingLabel}
        </>
      ) : (
        label || children
      )}
    </StyledButton>
  );
};
